import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const DeleteMaintenance = createAsyncThunk(
  "maintenance/DeleteMaintenance",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/asset-maintenance-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

